/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { outsidelabmasterApi } from '../api/outsidelabmaster.api';
import { switchMap, map } from 'rxjs/operators';
import { outsidelabmasterData, outsidelabmaster } from '../../../interfaces/masters/outsidelabmaster';

@Injectable()
export class outsidelabmasterService extends outsidelabmasterData {

  constructor(private api: outsidelabmasterApi) {
    super();
  }

//   fireRequest(data: Department, method: string) {
//     const links = data.links
//         ? data.links.find(x => x.method === method)
//         : null;
//     switch (method) {
//         case 'DELETE': {
//             return this.api.delete(links.href);
//         }
//         case 'POST': {
//             return this.api.add(links.href,data);
//         }
//         case 'PUT': {
//             return this.api.update(links.href, data);
//         }
//         default: {
//             console.log(`${links.method} not found!!!`);
//             break;
//         }
//     }
// }

  list(url: string): Observable<outsidelabmaster[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<outsidelabmaster>{
      return this.api.getById(url);
  }

  create(url: string, data:outsidelabmaster): Observable<outsidelabmaster> {
    return this.api.add(url,data);
  }

  update(url: string, data:outsidelabmaster): Observable<outsidelabmaster> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
